export default {
  namespaced: true,
  state: {
    newUser: {
      name: '',
      surname: '',
      province: '',
      typeInscription: '',
      email: '',
      confirmEmail: '',
      password: '',
      confirmPassword: '',
    },
    isNewUser: false,
  },
  actions: {
    setIsNewUser(context, value) {
      context.commit('setIsNewUser', value);
    },
    setName(context, value) {
      context.commit('setName', value);
    },
    setProvince(context, value) {
      context.commit('setProvince', value);
    },
    setTypeInscription(context, value) {
      context.commit('setTypeInscription', value);
    },
    setEmail(context, value) {
      context.commit('setEmail', value);
    },
    setPassword(context, value) {
      context.commit('setPassword', value);
    },
    setSurname(context, value) {
      context.commit('setSurname', value);
    },
    setConfirmPassword(context, value) {
      context.commit('setConfirmPassword', value);
    },
    resetNewUser(context, value) {
      context.commit('resetNewUser', value);
    },
    setConfirmEmail(context, value) {
      context.commit('setConfirmEmail', value);
    },
  },
  mutations: {
    setIsNewUser(state, value) {
      state.isNewUser = value;
    },
    setName(state, value) {
      state.newUser.name = value;
    },
    setProvince(state, value) {
      state.newUser.province = value;
    },
    setTypeInscription(state, value) {
      state.newUser.typeInscription = value;
    },
    setEmail(state, value) {
      state.newUser.email = value;
    },
    setPassword(state, value) {
      state.newUser.password = value;
    },
    setSurname(state, value) {
      state.newUser.surname = value;
    },
    setConfirmPassword(state, value) {
      state.newUser.confirmPassword = value;
    },
    setConfirmEmail(state, value) {
      state.newUser.confirmEmail = value;
    },
    resetNewUser(state, value) {
      state.newUser = {
        name: '',
        surname: '',
        province: '',
        typeInscription: '',
        email: '',
        confirmEmail: '',
        password: '',
        confirmPassword: '',
      };
    },
  },
};
